import * as Constants from '../../constants/Constants';
import moment from 'moment';

/**
 * @param {*} value1
 * @param {*} value2
 */
export default function areValuesEqual(value1, value2) {
    if (moment.isMoment(value1) && moment.isMoment(value2)) {
        return value1.format(Constants.DATE_FORMAT) === value2.format(Constants.DATE_FORMAT);
    }

    return value1 === value2;
}
